import React from 'react';
// Link is no longer directly used here for navigation if we want to intercept clicks

const Footer = ({ onNavigate }) => { // Accept onNavigate prop
  const currentYear = new Date().getFullYear();

  const handleFooterLinkClick = (e, path) => {
    e.preventDefault(); // Good practice if these were <a> tags, not strictly needed for <button>
    if (onNavigate) {
      onNavigate(path);
    } else {
      // Fallback if onNavigate is not provided (should not happen in your App.js setup)
      console.warn("onNavigate prop not provided to Footer. Defaulting to standard navigation for path:", path);
      // You might want a more robust fallback, e.g., using window.location or importing useNavigate here.
      // For simplicity, this example just logs. In a real app, you'd ensure onNavigate is always passed.
      // Or, conditionally render <Link> if onNavigate is not present.
    }
  };

  // Helper to create link-styled buttons
  const NavButton = ({ path, children }) => (
    <button
      onClick={(e) => handleFooterLinkClick(e, path)}
      className="hover:text-blue-600 dark:hover:text-blue-400 hover:underline focus:outline-none"
    >
      {children}
    </button>
  );

  return (
    <footer className="bg-gray-100 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 mt-12">
      <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8 text-center">
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 mb-4 text-sm text-gray-600 dark:text-gray-400">
          <NavButton path="/about-us">About Us</NavButton>
          <NavButton path="/contact-us">Contact Us</NavButton>
          <NavButton path="/privacy-policy">Privacy Policy</NavButton>
          <NavButton path="/terms-of-use">Terms of Use</NavButton>
          <NavButton path="/disclaimer">Disclaimer</NavButton>
          <NavButton path="/gdpr-compliance">GDPR Compliance</NavButton>
          <NavButton path="/FAQ">FAQ</NavButton>
          <NavButton path="/blog">Blog</NavButton>
        </div>
        <p className="text-sm text-gray-500 dark:text-gray-500">
          © {currentYear} TabDivider.com. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;